<script>
  import IconScale from "./IconScale.svelte";
  import { toProps } from "./utils";

  export let kind = "message";
  export let size = "small";
  export let skeleton = false;

  const activities = {
    default: toProps("fa-solid fa-wave-pulse", "GeneralTask"),

    // Legacy activity kinds, to be removed if no longer necessary
    email: toProps("fa-solid fa-envelope", "Message"),
    opens: toProps("fa-solid fa-envelope-open", "Message"),
    clicks: toProps("fa-solid fa-arrow-pointer", "Click"),
    replies: toProps("fa-solid fa-reply", "Reply"),
    connectionRequests: toProps("fa-solid fa-user-plus", "Connection"),
    generalTasks: toProps("fa-solid fa-clipboard-check", "GeneralTask"),
    voicemail: toProps("fa-solid fa-voicemail", "Calls"),
    calls: toProps("fa-solid fa-phone", "Calls"),
    inMails: toProps("fab fa-linkedin-in", "Linkedin"),
    interested: toProps("fa-heart", "Interested"),
    meeting: toProps("fa-calendar", "Calendar"),
    sms: toProps("fa-msm", "Sms"),

    11: toProps("fas fa-search-plus", "OutreachStart"), // Sourced
    12: toProps("fab fa-chrome", "OutreachStart"), // Sourced (Extension)
    13: toProps("fas fa-upload", "OutreachStart"), // Spreadsheet Upload
    131: toProps("fas fa-file-lines", "OutreachStart"), // Resume Upload
    14: toProps("fas fa-paper-plane", "OutreachStart"), // Added to Campaign
    15: toProps("fas fa-user-plus", "OutreachStart"), // Added Manually
    16: toProps("fas fa-database", "OutreachStart"), // Imported from CRM
    17: toProps("fas fa-s", "OutreachStart"), // Imported from SeekOot
    18: toProps("fas fa-phone-plus", "OutreachStart"), // Sourced (Dialer)
    19: toProps("fas fa-magnifying-glass", "OutreachStart"), // Sourced (Search Page)
    21: toProps("fas fa-pen", "Message"), // Draft Created
    22: toProps("fas fa-clock", "Message"), // Email Scheduled
    221: toProps("fas fa-exclamation-triangle", "Message"), // Unsent Email (unsent previous steps)
    222: toProps("fas fa-exclamation-triangle", "Message"), // Unsent Email (unrecognized previous outreach)
    23: toProps("fas fa-paper-plane-top", "Message"), // Initial Email
    24: toProps("fas fa-paper-plane-top", "Message"), // Follow-up Email
    241: toProps("fas fa-paper-plane-top", "Message"), // Emailed
    25: toProps("fab fa-linkedin-in", "Linkedin"), // InMail Scheduled
    26: toProps("fab fa-linkedin-in", "Linkedin"), // InMail Sent
    251: toProps("fab fa-linkedin-in", "Linkedin"), // InMail Scheduled
    252: toProps("fab fa-linkedin-in", "Linkedin"), // InMail Sent
    253: toProps("fab fa-linkedin-in", "Linkedin"), // InMail Sent
    261: toProps("fas fa-comment-dots", "Calls"), // SMS Scheduled
    262: toProps("fas fa-sms", "Calls"), // SMS Sent
    263: toProps("fas fa-sms", "Calls"), // SMS Received
    264: toProps("fab fa-whatsapp", "Calls"), // WhatsApp Sent
    265: toProps("fab fa-whatsapp", "Calls"), // WhatsApp Reply
    271: toProps("fas fa-user-plus", "Connection"), // Connection Request Scheduled
    272: toProps("fas fa-user-plus", "Connection"), // Connection Request Sent
    281: toProps("fas fa-phone", "Calls"), // Phone Call Scheduled
    282: toProps("fas fa-phone", "Calls"), // Call
    283: toProps("fas fa-phone-arrow-up-right", "Calls"), // Outbound Call
    284: toProps("fas fa-phone-arrow-down-left", "Calls"), // Inbound Call
    291: toProps("fas fa-clipboard", "GeneralTask"), // General Task Scheduled
    292: toProps("fas fa-clipboard-check", "GeneralTask"), // General Task Done
    31: toProps("fas fa-user-edit", "Message"), // Emailed Manually
    32: toProps("fas fa-trash-alt", "Message"), // Draft Deleted
    400: toProps("fas fa-reply", "Reply"), // Reply
    401: toProps("fab fa-linkedin", "Reply"), // InMail Reply
    40: toProps("fas fa-meh", "Reply"), // Neutral Reply
    41: toProps("fas fa-smile", "Reply"), // Positive Reply
    411: toProps("fas fa-smile", "Reply"), // Positive Reply (InMail)
    42: toProps("fas fa-frown", "Reply"), // Negative Reply
    421: toProps("fas fa-frown", "Reply"), // Negative Reply (InMail)
    422: toProps("fas fa-frown", "Reply"), // Not Interested
    423: toProps("fas fa-frown", "Reply"), // Not Interested (InMail)
    43: toProps("fas fa-question", "Reply"), // Unclear Reply
    431: toProps("fas fa-question", "Reply"), // Unclear Reply (InMail)
    44: toProps("fas fa-robot", "Reply"), // Autoreply Sent
    45: toProps("fas fa-hand", "Message"), // Email Bounced
    46: toProps("fas fa-robot", "Reply"), // Autoreply Received
    47: toProps("fas fa-share-all", "Reply"), // Forwarded On
    51: toProps("fas fa-calendar-circle-plus", "Calendar"), // Meeting Booked
    52: toProps("fas fa-video", "Calendar"), // Notetaker Meeting
    61: toProps("fas fa-circle-stop", "OutreachEnd"), // Outreach Stopped
    62: toProps("fas fa-trash-alt", "OutreachEnd"), // Deleted
    63: toProps("fas fa-ban", "OutreachEnd"), // Unsubscribed
    631: toProps("fas fa-ban", "OutreachEnd"), // Unsubscribed by InMail
    64: toProps("fas fa-pause", "OutreachEnd"), // Campaign Paused
    65: toProps("fas fa-xmark", "OutreachEnd"), // Removed from Campaign
    71: toProps("fas fa-fire", "GeneralTask"), // Added to Hotlist

    generalNote: toProps("fas fa-sticky-note", "GeneralTask"), // General Note
    phoneCallNote: toProps("fas fa-phone", "Calls"), // Phone Call Note
    smsNote: toProps("fas fa-sms", "Calls"), // SMS Note
    meetingNote: toProps("fas fa-sticky-note", "Calendar"), // Meeting Note
    interviewNote: toProps("fas fa-clipboard-question", "Calendar"), // Interview Note
    crmNote: toProps("fas fa-sticky-note", "OutreachStart"), // CRM Note

    opportunity: {
      backgroundColor: "aiCtaPurple",
      textGradient: "purpleBlue",
      class: "fa-kit fa-lightbulb-spark-solid",
    },

    aiToDo: {
      backgroundColor: "aiCtaPurple",
      textGradient: "purpleBlue",
      class: "fa-kit fa-ai-list",
    },

    manualToDo: {
      backgroundColor: "activityMessage_5",
      color: "activityMessage_50",
      class: "fas fa-list-check",
    },
  };
</script>

<IconScale {...activities[kind] ?? activities.default} {size} {skeleton} />
